import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DescriptionIcon from '@mui/icons-material/Description';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { Menu, MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import { LogoutOutlined, } from '@mui/icons-material';
import LogoCM from '../Components/img/Logo.jpg'
import "./SideBar.css";
import { Link } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { API_URL } from '../Components/config'
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';



const drawerWidth = 240;

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      isClosing: false,
      selectedOption: this.props.poNumber ? this.props.poNumber : "",
      // searchValue: '',
      suggestions: [],
      searchValue: [],
      isPoDetailsEdit: window.location.pathname === "/PoDetailsEdit" ? true : false,
      anchorEl: null
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  componentDidMount() {
  }


  handleDrawerClose = () => {
    this.setState({
      isClosing: true,
      mobileOpen: false
    });
  };

  handleDrawerTransitionEnd = () => {
    this.setState({
      isClosing: false
    });
  };

  handleDrawerToggle = () => {
    const { isClosing } = this.state;

    if (!isClosing) {
      this.setState(prevState => ({
        mobileOpen: !prevState.mobileOpen
      }));
    }
  };

  handleDrawerToggleTouch = () => {
    const { isClosing } = this.state;

    if (!isClosing) {
      this.setState(prevState => ({
        mobileOpen: !prevState.mobileOpen
      }));
    }
  };

  handleLogout = async () => {
    try {
      const confirmed = await Swal.fire({
        title: 'Are you sure you want to log out?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#055032',
        // cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',

      });

      if (confirmed.isConfirmed) {
          console.log('Logout successful');
          localStorage.clear()
          sessionStorage.clear()
          window.location.href = '/'; // Redirect to homepage
       
      }
    } catch (error) {
      console.error('Error during logout:', error);
      // Handle logout error
    }
  };

  handleClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  render() {
    // this.state.selectedOpti  on=this.props.poNumber ? this.props.poNumber  :"";
    const { anchorEl } = this.state;
    const { window } = this.props;
    const { searchValue, suggestions } = this.state;

    const drawer = (
      <div>
        <div className="d-flex align-items-center">
          <img src={LogoCM} width="220" height="80" className="d-inline-block align-top" alt="" style={{ marginLeft: "-11px", marginTop: "15px" }} />
        </div>
        <Toolbar />

        {/* <Divider /> */}
        <List style={{marginTop:'-27px'}}>
          <ListItem disablePadding component={Link} to="/TicketBooking" selected={this.state.activeLink === '/TicketBooking'} onClick={() => this.setState({ activeLink: '/TicketBooking' })}>
            <ListItemButton>
              <ListItemIcon>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText primary="Ticket Booking" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding selected={this.state.activeLink === '/CityMaster' || this.state.activeLink === '/AirlineMaster' || this.state.activeLink === '/PartyMaster'}  onClick={() => this.setState({ activeLink: '/CityMaster' })} >
            <ListItemButton onClick={this.handleClick}>
              <ListItemIcon>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText primary="Master Screens" />
            </ListItemButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem component={Link} to="/CityMaster" onClick={() => { this.handleClose(); this.setState({ activeLink: '/CityMaster' }); }} selected={this.state.activeLink === '/CityMaster'}  >City Master</MenuItem>
              <MenuItem component={Link} to="/AirlineMaster" onClick={() => { this.handleClose(); this.setState({ activeLink: '/AirlineMaster' }); }} selected={this.state.activeLink === '/AirlineMaster'}>Airline Master</MenuItem>
              <MenuItem component={Link} to="/PartyMaster" onClick={() => { this.handleClose(); this.setState({ activeLink: '/PartyMaster' }); }} selected={this.state.activeLink === '/PartyMaster'}>Party Master</MenuItem>

              {/* Add more MenuItem components for additional bookings */}
            </Menu>
          </ListItem>
          <ListItem disablePadding onClick={this.handleLogout}>
            <ListItemButton>
              <ListItemIcon>
                <LogoutOutlined />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          </ListItem>
        </List>


      </div >
    );

    // Remove this const when copying and pasting into your project.
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
      <>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
            }}
          >
            <Toolbar style={{ backgroundColor: "white" }}>
              <IconButton
                // color="red"
                className='MenuIcon'
                aria-label="open drawer"
                edge="start"
                onClick={this.handleDrawerToggle}
                onTouchStart={this.handleDrawerToggleTouch}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div" style={{ color: "black", flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                <span className='NavBar'>{this.props.ScreenName}</span>
              </Typography>
            </Toolbar>
          </AppBar>

          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
              container={container}
              variant="temporary"
              open={this.state.mobileOpen}
              onTransitionEnd={this.handleDrawerTransitionEnd}
              onClose={this.handleDrawerClose}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', sm: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
        
          <Box
            component="main"
            sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
          >
            <Toolbar />
          
            <Dialog
              open={this.state.logoutModalOpen}
              onClose={this.handleLogoutCancelled}
              aria-labelledby="logout-confirmation-modal-title"
              aria-describedby="logout-confirmation-modal-description"
            >
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 4,
              }}>
                <h4 id="logout-confirmation-modal-title">Are you sure you want to logout?</h4>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                  <Button onClick={this.handleLogoutConfirmed} variant="contained">Yes</Button>
                  <Button onClick={this.handleLogoutCancelled} sx={{ marginLeft: 1 }} variant="contained">No</Button>
                </Box>
              </Box>
            </Dialog>

          </Box>

        </Box>
        {/* <div className='container'> */}

        {/* </div> */}
      </>
    );
  }
}

SideBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default SideBar;
